export { AddPaymentMethodPage } from './src/ui/add-payment-method-page';
